import { render, staticRenderFns } from "./choice_general_tab.vue?vue&type=template&id=b9b8e5da&scoped=true&"
import script from "./choice_general_tab.vue?vue&type=script&lang=js&"
export * from "./choice_general_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b8e5da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9b8e5da')) {
      api.createRecord('b9b8e5da', component.options)
    } else {
      api.reload('b9b8e5da', component.options)
    }
    module.hot.accept("./choice_general_tab.vue?vue&type=template&id=b9b8e5da&scoped=true&", function () {
      api.rerender('b9b8e5da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/choice/location/tabs/choice_general_tab.vue"
export default component.exports